import axios from 'axios';

// La URL base viene de las variables de entorno (REACT_APP_API: https://reports.barlleno.app)
const baseURL = process.env.REACT_APP_API || process.env.REACT_APP_API_DEV || "https://reports.barlleno.app";

console.log(baseURL, "direccion");
export const apiClient = axios.create({

  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000, // Aumentado a 60 segundos por si el backend está muy lento
});

// Interceptor para agregar headers comunes o manejar tokens en cada peticion (opcional)
apiClient.interceptors.request.use((config) => {
  // A futuro, si se usa autenticación basada en JWT, el token se añadiría aquí:
  // const token = localStorage.getItem('token');
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`;
  // }
  return config;
});

// Interceptor global para manejo de errores
apiClient.interceptors.response.use(
  (response) => {
    // Cualquier código de estado dentro del rango de 2xx causa que esta función se active
    return response;
  },
  (error) => {
    // Cualquier código de estado que salga del rango de 2xx causa que esta función se active
    // Aquí puedes manejar errores globales, como sesión expirada (401)
    if (error.response) {
      if (error.response.status === 401) {
        console.warn("Sesión expirada o no autorizada.");
        // Ejemplo: sessionService.destroySession(); window.location.href = '/login';
      } else {
        console.error("API Error Status:", error.response.status, error.response.data);
      }
    } else if (error.request) {
      console.error("Error de Red: No se recibió respuesta del servidor.");
    } else {
      console.error("Error al configurar la petición:", error.message);
    }

    return Promise.reject(error);
  }
);
